export default "__VITE_ASSET__BTECzAb2__"